import React, { useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Box, Button, Modal } from '@mui/material';

import api from '@/services/api';

import Spinner from '@/views/components/Spinner/Spinner';

const style = {
	maxWidth: '660px !important',
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	background: '#FFFFFF',
	boxShadow: '0px 3px 6px #00000029',
	borderRadius: '6px',
};

const ModalDeleteUser = ({ itemToDelete, setItemToDelete, reloadList, showModalDeleteItem, setShowModalDeleteItem }) => {
	const { dict } = useSelector((state) => state.app);
	const [ loading, setLoading ] = useState(false);

	const handleClose = useCallback(() => {
		setLoading(false);
		setShowModalDeleteItem(false);
		reloadList();
		setItemToDelete(null);
	}, [ reloadList, setItemToDelete, setShowModalDeleteItem, setLoading ]);

	const removeConfirmed = () => {
		setLoading(true);
		api.delete(`/users/${itemToDelete.id}`)
			.then(() => {
				handleClose();
			}).catch(() => {
				handleClose();
			});
	};

	return (
		<Modal
			open={ showModalDeleteItem }
			onClose={ handleClose }
			aria-labelledby='modal-modal-title'
			aria-describedby='modal-modal-description'
		>
			<Box
				sx={ style }
			>
				{
					loading && (
						<Spinner
							addClass='dictionary__spinner'
						/>
					)
				}

				<h3 className="modal-children__title">{dict.users.modalDelete.title}</h3>
				<hr />
				{itemToDelete && <div>
					{dict.users.modalDelete.desc1} <strong>{itemToDelete.displayName}?</strong><br/>
					{dict.users.modalDelete.desc2}
				</div>}
				<section className='form__buttons'>
					<Button
						color='primary'
						variant='contained'
						className='button__transparent'
						sx={ { textTransform: 'none' } }
						onClick={ () => handleClose() }
					>
						{dict.cancel}
					</Button>
					<Button
						color='primary'
						variant='contained'
						fullWidth
						className='button__blue'
						onClick={ () => removeConfirmed() }
						sx={ { textTransform: 'none' } }
					>
						{dict.users.modalDelete.delete}
					</Button>
				</section>

			</Box>
		</Modal>
	);
};

export default ModalDeleteUser;